import styled from 'styled-components';

export const ImageContainer = styled.div`
  img {
    width: 80%;
    max-width: 100%;
    height: auto;
    max-height: 40vh;
    object-fit: contain;
  }

  @media (max-height: 600px) {
    visibility: hidden;
  }
`;

export const TitleLeftPanel = styled.p`
  max-width: 430px;
  font-size: 2em;
  text-align: center;
  font-weight: 200;
  line-height: 1em;
  color: ${({ color }) => color || '#0015c1'};
`;

export const FrasesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 1.5em;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
`;

export const FrasesTitle = styled.p`
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
`;

export const ContainerProcessInterview = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  @media (max-width: 768px) {
  }
`;
